import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { predictQuotaExhaustion } from '@/features/usage/lib/usage-utils';
import { Usage } from '@activepieces/shared';

type QuotaExhaustionInfoProps = {
  usage: Usage;
  quota: number;
};

export const QuotaExhaustionInfo = ({
  usage,
  quota,
}: QuotaExhaustionInfoProps) => {
  const { t, i18n } = useTranslation();
  const prediction = useMemo(
    () => predictQuotaExhaustion(usage, quota),
    [usage, quota],
  );

  if (!prediction) {
    return null;
  }

  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex items-center justify-between gap-1 text-xs">
        <span className="font-medium uppercase text-muted-foreground">
          {t('Limit reached on')}
        </span>
        <span className="text-sm text-red-700 font-semibold">
          ~
          {prediction.date.toLocaleDateString(i18n.language, {
            day: 'numeric',
            month: 'long',
          })}
        </span>
      </div>
      <span className="text-xs text-muted-foreground">
        <Trans
          i18nKey="In <strong>{{count}} days</strong> at the current rate"
          values={{ count: prediction.daysRemaining }}
        />
      </span>
    </div>
  );
};
